var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNewDocumentWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 22,
    viewBox: "0 0 54 68",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M33.6663 0.666748H6.99967C5.23156 0.666748 3.53587 1.36913 2.28563 2.61937C1.03539 3.86961 0.333008 5.5653 0.333008 7.33341V60.6667C0.333008 62.4349 1.03539 64.1305 2.28563 65.3808C3.53587 66.631 5.23156 67.3334 6.99967 67.3334H46.9997C48.7678 67.3334 50.4635 66.631 51.7137 65.3808C52.964 64.1305 53.6663 62.4349 53.6663 60.6667V20.6667L33.6663 0.666748ZM46.9997 60.6667H6.99967V7.33341H30.333V24.0001H46.9997V60.6667Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M34 39H28V45H26V39H20V37H26V31H28V37H34V39Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNewDocumentWhite);
export default __webpack_public_path__ + "static/media/newDocumentWhite.23962eca372fd96b45fb5858c695fc70.svg";
export { ForwardRef as ReactComponent };